import { render, staticRenderFns } from "./AddOurGalleryImage.vue?vue&type=template&id=7151b203&"
import script from "./AddOurGalleryImage.vue?vue&type=script&lang=js&"
export * from "./AddOurGalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./AddOurGalleryImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports